import React, { useState } from "react";
import { Card, Flex, Button, Row, Col, Input, Space, Select } from 'antd';
import RecipeCard from "./RecipeCard";
import "./RecipeList.css";


const RecipeList = (props) => {
    const [search, setSearch] = useState("");
    const [selection, setSelection] = useState(1);

    const isInSearch = (recipeObject) => {
        return recipeObject.recipeId.name.toLowerCase().includes(search.toLowerCase()) || recipeObject.recipeId.product.name.toLowerCase().includes(search.toLowerCase()) || recipeObject.recipeId.recipe.toLowerCase().includes(search.toLowerCase());
    }

    const isInSelect = (recipeObject) => {
        switch (selection) {
            case 1:
                return true;
            case 2:
                return recipeObject.learned;
            case 3:
                return !recipeObject.learned;
            case 4:
                return recipeObject.learned && recipeObject.craftable;
            case 5:
                return recipeObject.learned && !recipeObject.craftable;
            case 6:
                return recipeObject.favouritePotion;
        }
    }


    return (
        <div>
            <div className="searchWrapper">
                <Input className='inputField' placeholder="Search..." onChange={v => setSearch(v.target.value)} />
                <Select
                    size="small"
                    className="selectField"
                    onSelect={v => setSelection(v)}
                    placeholder="Select a person"
                    style={{ fontSize: "10" }}
                    options={[
                        { value: 1, label: 'All' },
                        { value: 2, label: 'Only Learned' },
                        { value: 3, label: 'Only Unlearned' },
                        { value: 4, label: 'Only Craftable' },
                        { value: 5, label: 'Only Uncraftable' },
                        { value: 6, label: 'Favourite Potion' },
                    ]}
                />
            </div>
            <Row gutter={[16, 16]}>
                {props.data.filter(a => isInSearch(a) && isInSelect(a)).sort((a, b) => {
                    if (a.craftable && !b.craftable) {
                        return -1;
                    }
                    if (!a.craftable && b.craftable) {
                        return 1;
                    } else {
                        return a.recipeId.name.localeCompare(b.recipeId.name);
                    }
                }).map(item => (
                    <Col key={item.id} span={12}>
                        <RecipeCard key={item.id} data={item} changeMethod={props.changeMethod} />
                    </Col>
                ))
                }
            </Row>
        </div>
    );
};

export default RecipeList;